import React, { useState } from 'react';
import { Session } from '../store';

interface Props { sessions: Session[]; }

export function MiniCalendar({ sessions }: Props) {
  const [offset, setOffset] = useState(0); // months offset from today
  const base = new Date();
  base.setDate(1);
  base.setMonth(base.getMonth() + offset);

  const year = base.getFullYear();
  const month = base.getMonth();
  const monthStr = base.toLocaleString('es', { month: 'long', year: 'numeric' });

  const firstDow = new Date(year, month, 1).getDay(); // 0=Sun
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  // Map date → profit
  const dayMap: Record<string, number> = {};
  for (const s of sessions) {
    if (!s.date.startsWith(`${year}-${String(month + 1).padStart(2, '0')}`)) continue;
    const d = parseInt(s.date.split('-')[2]);
    dayMap[d] = (dayMap[d] || 0) + s.netProfit;
  }

  const cells: (number | null)[] = [];
  for (let i = 0; i < firstDow; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  return (
    <div className="panel mini-calendar">
      <div className="cal-header">
        <button className="cal-nav" onClick={() => setOffset(o => o - 1)}>‹</button>
        <span className="panel-title">{monthStr.toUpperCase()}</span>
        <button className="cal-nav" onClick={() => setOffset(o => o + 1)}>›</button>
      </div>
      <div className="cal-dow">
        {['D','L','M','X','J','V','S'].map(d => <span key={d}>{d}</span>)}
      </div>
      <div className="cal-grid">
        {cells.map((d, i) => {
          if (d === null) return <span key={`e${i}`} className="cal-day empty" />;
          const profit = dayMap[d];
          const cls = profit === undefined ? '' : profit > 0 ? 'win' : profit < 0 ? 'loss' : 'breakeven';
          return (
            <span key={d} className={`cal-day ${cls}`} title={profit !== undefined ? `$${profit.toFixed(2)}` : ''}>
              {d}
            </span>
          );
        })}
      </div>
    </div>
  );
}
